<template>
  <div class="selectDropdown" @click.stop="toggle" :disablePopup="disablePopup" :class="[ disablePopup? 'disabled' : '']">
    <div v-if="!isTable" class="select">
      <input type="text" 
          :value="computedSelectedValue"
          required :class="{error : error, standardInput : type, small: size}">
      <div class="select__title subhead" :class="{standardLabel : type}">{{label}}</div>
      <div class="select__icon" :class="{ standardIcon : type }">
        <i v-if="isShown" class="icon-chevronup"></i>
        <i v-else class="icon-chevrondown"></i>
      </div>
    </div>
    <div v-else class="selectTable">
      <input type="text"
          :value="computedSelectedValue"
          required :class="{error : error, standardInput : type}">
      <div class="select__title subhead" :class="{standardLabel : type}">{{label}}</div>
      <div class="select__icon" :class="{ standardIcon : type }">
        <i v-if="isShown" class="icon-chevronup"></i>
        <i v-else class="icon-chevrondown"></i>
      </div>
    </div>
    <div class="popup" v-if="isShown">
      <div class="popup__loading" v-if="loading">
        <adx-loading/>
      </div>
      <div v-else>
        <div v-if="insertAddNew" class="popup__background">
          <div class="item addNew"
            @click.stop="emitAddNew">
            <span class=""></span>
            <span class="subhead text">Add New</span>
          </div>
        </div>
        <div class="popup__background"
          v-for="option in options" :key="option.id">
          <div v-if="!isTable" class="item"
            @click.stop="onItemClick(option)">
            <span :class="{ 'icon-check': isChecked(option) }"></span>
            <span class="subhead text"
              >{{ option.label }}</span>
          </div>
          <div v-else class="itemTable"
            @click.stop="onItemClick(option)">
            <span :class="isChecked(option) "></span>
            <span class="subhead text"
              >{{ option.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <p v-if="validationError" class="msg-error small-font">{{message || error}}</p>
  </div>
</template>

<script>
import Vue from 'vue'
import * as validationLib from '@/lib/validation/'
import LoadingPrimary from '@/components/Loading/Primary'

const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-select-dropdown',
  components: {
    'adx-loading': LoadingPrimary,
  },
  props: {
    loading: {
      required: false,
      default: false,
    },
    size:{
      required: false
    },
    options: {
      required: true
    },
    value: {
      required: false
    },
    error: {
      required: false
    },
    label: {
      required: false
    },
    validation: {
      required: false
    },
    type: {
      required: false
    },
    needFocus: {
      required: false,
      default: false
    },
    isInitial: {
      required: false
    },
    needEventEmitter: {
      required: false,
      default: false
    },
    itemId: {
      required: false
    },
    errorLabel: {
      required: false
    },
    insertAddNew: {
      required: false
    },
    isTable: {
      required: false,
      default: false
    },
    disablePopup: {
      required: false
    }
  },
  data() {
    return {
      valid: undefined,
      message: undefined,
      isShown: false,
      selectedText: '',
      selectedItem: undefined
    }
  },
  mounted() {
    if (this.value != null) {
      const selectedOption = this.options.filter(x => x.value === this.value).pop()
      this.$data.selectedItem = selectedOption
      this.selectedText = selectedOption? selectedOption.value : ''
    }
    if (!this.validation) {
      this.$emit(`update:isInitial`, false)
    }
    this.$nextTick(function () {
      Vue.$broker.$on('app-click', this.onAppClick.bind(this))
    })
  },
  methods: {
    toggle() {
      if(this.disablePopup){
        this.isShown = false
      }else{
        this.isShown = !this.isShown
      }
      
    },
    onItemClick(item) {
      this.$data.selectedItem = item
      this.$data.selectedText = item.value
      this.$data.isShown = false
      const params = {
        item: item,
        id: this.itemId
      }
      this.$emit(`selected`, params)
    },
    isChecked(item) {
      return this.$data.selectedItem === item
    },
    onAppClick(sender) {
      if (sender === this) return
      this.$data.isShown = false
    },
    validateInput(value) {
      if (value == null) value = this.value
      if (this.validation) {
        let usedLabel = null
        if (this.errorLabel) {
          usedLabel = this.errorLabel
        } else {
          usedLabel = this.label
        }
        const { valid, message } = validate(this.validation, value, usedLabel)
        if(valid) {
          if (this.needEventEmitter) this.$emit(`selectedValue`, value)
          this.$emit(`update:value`, value)
          this.$emit(`update:error`, false)
        } else {
          this.$emit(`update:value`, ``)
          this.$emit(`update:error`, !valid)
        }
        this.valid = valid
        this.message = message
      } else {
        if (this.needEventEmitter) this.$emit(`selectedValue`, value)
        this.$emit(`update:value`, value)
        this.$emit(`update:error`, false)
      }
      this.$emit(`update:isInitial`, false)
    },
    emitAddNew() {
      this.$emit(`addNew`)
      this.isShown = false
    }
  },
  watch: {
    selectedText() {
      this.validateInput(this.selectedText)
    },
    value:{
       handler(n, o) {
        if (this.value != null) {
          if (this.value == '') {
            this.validateInput(this.selectedText)
          } else {
            const selectedOption = this.options.filter(x => x.value === this.value).pop()
            this.$data.selectedItem = selectedOption
            this.selectedText = selectedOption.value
          }
        }
       },
        deep: true
    },
    options() {
      if (this.value != null) {
        const selectedOption = this.options.filter(x => x.value === this.value).pop()
        this.$data.selectedItem = selectedOption
        this.selectedText = selectedOption.value
      }
    }
  },
  computed: {
    computedSelectedValue: function () {
      const selectedItem = this.options.filter(x => x.value === this.selectedText).pop()
      if (selectedItem) {
        return selectedItem.label
      }
      return this.selectedText
    },
    validationError: function () {
      if (this.error) {
        return this.error
      }
      return this.valid === undefined ? false : !this.valid
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>